import Vue from 'vue'
import Vuex from 'vuex'
import AllModuleConfig from './config.modules'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ...AllModuleConfig
  }
})
